var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#DCEAF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5019_3721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9836 22.305L31.1327 15.6383C30.8677 13.5642 29.0911 12 26.9994 12H17.0177C14.9269 12 13.1502 13.5642 12.8852 15.6383L12.0336 22.305C11.8819 23.4925 12.2486 24.6883 13.0402 25.5867C13.8311 26.485 14.9702 27 16.1669 27H21.1669V30.3333H17.8336C17.3736 30.3333 17.0002 30.7058 17.0002 31.1667C17.0002 31.6275 17.3736 32 17.8336 32H26.1669C26.6269 32 27.0002 31.6275 27.0002 31.1667C27.0002 30.7058 26.6269 30.3333 26.1669 30.3333H22.8336V27H27.8519C29.0486 27 30.1886 26.485 30.9786 25.5867C31.7694 24.6892 32.1353 23.4925 31.9836 22.305ZM29.4794 15.85L29.8394 18.6667H25.6994L25.3869 13.6667H27.0002C28.2552 13.6667 29.3202 14.605 29.4794 15.85ZM19.5527 25.3333L19.8652 20.3333H24.1327L24.4452 25.3333H19.5527ZM19.9694 18.6667L20.2819 13.6667H23.7161L24.0286 18.6667H19.9694ZM17.0177 13.6667H18.6119L18.2994 18.6667H14.1786L14.5386 15.85C14.6977 14.605 15.7636 13.6667 17.0177 13.6667ZM14.2902 24.485C13.8161 23.9467 13.5961 23.2283 13.6861 22.5167L13.9652 20.3333H18.1952L17.8827 25.3333H16.1661C15.4486 25.3333 14.7644 25.0242 14.2902 24.485ZM29.7269 24.485C29.2528 25.0233 28.5686 25.3333 27.8511 25.3333H26.1152L25.8027 20.3333H30.0519L30.3311 22.5167C30.4219 23.2283 30.2011 23.9467 29.7269 24.485Z",
    fill: "#5A7994"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5019_3721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbTv);
export default __webpack_public_path__ + "static/media/wbTv.4e0af3f66367d9ea84b0c11f437b83d9.svg";
export { ForwardRef as ReactComponent };